import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

//import reportWebVitals from "./reportWebVitals";

import { BrowserRouter } from 'react-router-dom'

import { Provider } from 'react-redux';
//reducer
import { store } from './store'

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Provider store={store}>                
                <App />
            </Provider>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
